<template>
    <t-space direction="vertical" style="width: 100%;" size="small">
        <t-space></t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card brodered style="width: 85.5vw;" title="采购统计">
                <t-typography-text>
                    待确认商品列表中为采购入库单填写时中的商品条目，经确认后，商品将完成入库
                </t-typography-text>
            </t-card>
            <t-space></t-space>
        </t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card brodered  title="待确认商品列表">
                <t-space direction="vertical">
                    <t-space direction="horizontal">
                        <t-button variant="outline" theme="primary" @click="StockGoodsInfoList">确认将所选商品项商品入库</t-button>
                        <t-button variant="outline" theme="danger" @click="RejectGoodsInfoList">确认将所选商品项商品拒绝入库</t-button>
                        <t-button variant="dashed" theme="primary" @click="StockAll">全部入库</t-button>
                        <t-button variant="dashed" theme="danger" @click="RejectAll">全部拒绝入库</t-button>
                    </t-space>
                    <t-table
                            :max-height="550"
                            row-key="index"
                            cell-empty-content="-"
                            v-model:displayColumns="dispalyColumns"
                            :pagination="pagination"
                            :selected-row-keys="selectedRowKeys"
                            :data="waitingCheckGoodsList"
                            :columns="goodsListColumns"
                            :select-on-row-click="true"
                            @select-change="rehandleSelectChange">
                    </t-table>
                </t-space>
            </t-card>
            <t-space></t-space>
        </t-space>
    </t-space>
</template>

<script lang="jsx" setup>
import request from '@/request/request';
import { onMounted, ref } from 'vue'
import { NotifyPlugin } from 'tdesign-vue-next';

const Config = ref({})
const waitingCheckGoodsList = ref([])
const selectedRowKeys = ref([]);
const pagination = ref({
    pageSize: 8,
    defaultPageSize: 20,
    total: 100,
    defaultCurrent: 1,
    showPageSize: false,
    onCurrentChange: (number)=>{
        selectedRowKeys.value = []
        request.RequestWaitingCheckGoodsInfoList(number,8,(res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                data[i].index = i
            }
            waitingCheckGoodsList.value = data
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品信息请求失败.' + err,
        })
    })
    }
});
//单据细节查看中表格的列定义
const goodsListColumns = ref([
    {title:"该页全选",colKey: 'row-select',type: 'multiple',width: 50},
    { title: '所属仓库',colKey: 'warehouse'},
    { title: '来源单据',colKey: 'bindingBillOfDocumentId'},
    { title: '商品编号',colKey: 'billOfDocumentGoodsId'},
    { title: '商品名称',colKey: 'billOfDocumentGoodsName'},
    { title: '商品重量',colKey: 'billOfDocumentGoodsWeight'},
    { title: '商品高度',colKey: 'billOfDocumentGoodsHeight'},
    { title: '商品长度',colKey: 'billOfDocumentGoodsLength'},
    { title: '商品品牌',colKey: 'billOfDocumentBrand'},
    { title: '商品数量',colKey: 'billOfDocumentGoodsAmount'},
    { title: '商品规格',colKey: 'billOfDocumentModel'},
    { title: '商品产地',colKey: 'billOfDocumentPlaceOfProduction'},
    { title: '商品单价',colKey: 'billOfDocumentGoodsPrice'},
    { title: '批次号',colKey: 'batchNumber'},
    { title: '保质期',colKey: 'qualityGuaranteePeriod'},
    { title: '享受折扣',colKey: 'discount'},
    { title: '含税单价',colKey: 'billOfDocumentGoodsPriceIncludeTax'},
])
const dispalyColumns = ref([
                            'row-select',
                            'warehouse',
                            "bindingBillOfDocumentId",
                            'billOfDocumentGoodsId',
                            'billOfDocumentGoodsName',
                            'billOfDocumentGoodsWeight',
                            'billOfDocumentGoodsHeight',
                            'billOfDocumentGoodsLength',
                            'billOfDocumentBrand',
                            'billOfDocumentGoodsAmount',
                            'billOfDocumentModel',
                            'billOfDocumentPlaceOfProduction',
                            'billOfDocumentGoodsPrice',
                            'batchNumber',
                            'qualityGuaranteePeriod',
                            'discount',
                            'billOfDocumentGoodsPriceIncludeTax',
                            "operate"
                        ])

//确认将所选商品项商品入库
const StockGoodsInfoList = ()=>{
    let selectDataList = []
    for(let i = 0;i < selectedRowKeys.value.length;i++){
        selectDataList.push(waitingCheckGoodsList.value[selectedRowKeys.value[i]])
    }
    request.RequestWaitingCheckGoodsStock(selectDataList,(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "请求成功",
                content: "数据已入库",
                duration: 3000
            })
            for(let i = 0;i < selectedRowKeys.value.length;i++) {
                waitingCheckGoodsList.value.splice(selectedRowKeys.value[i],1)
            }
            for(let i = 0; i < waitingCheckGoodsList.value.length; i++) {
                waitingCheckGoodsList.value[i].index = i
            }
            selectedRowKeys.value = []
            pagination.value.total = pagination.value.total - selectedRowKeys.value.length
            sessionStorage.setItem("waiting_check_goods_amount",pagination.value.total)

        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品信息请求失败.' + err,
            duration: 3000
        })
    })
    console.log("STOCK GOODS INFO LIST",JSON.stringify(selectDataList))
}

const StockAll = ()=>{
    request.RequestWaitingCheckGoodsStockAll((res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "请求成功",
                content: "数据已入库",
                duration: 3000
            })
            selectedRowKeys.value = []
            waitingCheckGoodsList.value = []
            pagination.value.total = 0
            sessionStorage.setItem("waiting_check_goods_amount",pagination.value.total)
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品信息请求失败.' + err,
            duration: 3000
        })
    })
}

const RejectGoodsInfoList = ()=>{
    let selectDataList = []
    for(let i = 0;i < selectedRowKeys.value.length;i++){
        selectDataList.push(waitingCheckGoodsList.value[selectedRowKeys.value[i]])
        selectDataList[i].bindingUserId = parseInt(sessionStorage.getItem("user_id"))
    }
    request.RequestWaitingCheckGoodsReject(selectDataList,(res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "请求成功",
                content: "数据已拒绝入库",
                duration: 3000
            })
            for(let i = 0;i < selectedRowKeys.value.length;i++) {
                waitingCheckGoodsList.value.splice(selectedRowKeys.value[i],1)
            }
            selectedRowKeys.value = []
            pagination.value.total = pagination.value.total - selectedRowKeys.value.length
            sessionStorage.setItem("waiting_check_goods_amount",pagination.value.total)
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败。' + err,
                duration: 3000
            })
    })
}
const RejectAll = ()=>{
    request.RequestWaitingCheckGoodsRejectAll((res)=>{
        if(res.data.success) {
            NotifyPlugin.success({
                title: "请求成功",
                content: "数据已拒绝入库",
                duration: 3000
            })
            selectedRowKeys.value = []
            waitingCheckGoodsList.value = []
            pagination.value.total = 0
            sessionStorage.setItem("waiting_check_goods_amount",pagination.value.total)
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品信息请求失败.' + err,
            duration: 3000
        })
    })
}

//表格多选框选择改变时回调事件
const rehandleSelectChange = (value, ctx) => {
    selectedRowKeys.value = value;
    console.log(value, ctx);
};
onMounted(()=>{
    let config = JSON.parse(sessionStorage.getItem("config"))
    for(let i = 0; i< config.length; i++) {
        if(config[i].type === "采购入库单") {
            Config.value = config[i]
            ConfigRead()
            break
        }
    }
    request.RequestWaitingCheckGoodsInfoList(0,8,(res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                data[i].index = i
            }
            waitingCheckGoodsList.value = data
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品信息请求失败.' + res.data.tag,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品信息请求失败.' + err,
        })
    })
    request.RequestWaitingCheckGoodsAmount((res)=>{
        if(res.data.success) {
            pagination.value.total = res.data.data
            sessionStorage.setItem("waiting_check_goods_amount",res.data.data)
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '待审核商品数量请求失败.' + res.data.tag,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '待审核商品数量请求失败.' + err,
        })
    })
})

const ConfigRead = ()=>{
            console.log("Config",Config)
            if(!Config.value.idVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !== "billOfDocumentGoodsId"})
            else dispalyColumns.value.push("billOfDocumentGoodsId")
            if(!Config.value.nameVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsName"})
            else dispalyColumns.value.push("billOfDocumentGoodsName")
            if(!Config.value.weightVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsWeight"})
            else dispalyColumns.value.push("billOfDocumentGoodsWeight")
            if(!Config.value.heightVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsHeight"})
            else dispalyColumns.value.push("billOfDocumentGoodsHeight")
            if(!Config.value.lengthVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsLength"})
            else dispalyColumns.value.push("billOfDocumentGoodsLength") 
            if(!Config.value.brandVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentBrand"})
            else dispalyColumns.value.push("billOfDocumentBrand")
            if(!Config.value.amountVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsAmount"})
            else dispalyColumns.value.push("billOfDocumentGoodsAmount")
            if(!Config.value.modelVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentModel"})
            else dispalyColumns.value.push("billOfDocumentModel")
            if(!Config.value.placeOfProductionVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentPlaceOfProduction"})
            else dispalyColumns.value.push("billOfDocumentPlaceOfProduction")
            if(!Config.value.priceVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsPrice"})
            else dispalyColumns.value.push("billOfDocumentGoodsPrice")
            if(!Config.value.batchNumberVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="batchNumber"})
            else dispalyColumns.value.push("batchNumber")
            if(!Config.value.qualityGuaranteePeriodVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="qualityGuaranteePeriod"})
            else dispalyColumns.value.push("qualityGuaranteePeriod")
            if(!Config.value.discountVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="discount"})
            else dispalyColumns.value.push("discount")
            if(!Config.value.priceIncludeTaxVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsPriceIncludeTax"})
            else dispalyColumns.value.push("billOfDocumentGoodsPriceIncludeTax")
}
</script>

<style lang="less" scoped>
</style>